import { render, staticRenderFns } from "./ComboTotalPriceField.vue?vue&type=template&id=1386dbac&scoped=true"
import script from "./ComboTotalPriceField.vue?vue&type=script&lang=ts"
export * from "./ComboTotalPriceField.vue?vue&type=script&lang=ts"
import style0 from "./ComboTotalPriceField.vue?vue&type=style&index=0&id=1386dbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386dbac",
  null
  
)

export default component.exports